module.exports = __webpack_public_path__ + "assets/9dc3c9f4c187518be088dd7dacc35429.png";